import type { MarketplaceLead } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { DispensariesApi } from 'api/DispensariesApi';
import { DISPENSARY_MARKETPLACE_LEADS_KEY } from 'hooks/keys';

export function useDispensaryMarketplaceLeads(dispensaryId: string) {
  const dispensaryApi = new DispensariesApi();

  const {
    data: dispensaryMarketplaceLeads,
    isLoading: isLoadingDispensaryMarketplaceLeads,
    isError: isLoadingDispensaryMarketplaceLeadsError
  } = useQuery<MarketplaceLead[] | undefined>({
    enabled: !!dispensaryId.length,
    queryKey: [DISPENSARY_MARKETPLACE_LEADS_KEY, dispensaryId],
    queryFn: () => dispensaryApi.getMarketplaceLeads(dispensaryId)
  });

  return {
    dispensaryMarketplaceLeads,
    isLoadingDispensaryMarketplaceLeads,
    isLoadingDispensaryMarketplaceLeadsError
  };
}
